<template>
  <v-form ref="formCambiarPass">
  <v-dialog :value="true" persistent max-width="450">
      <v-card>
          <v-card-title class="text-h3 primary--text">
              CAMBIAR CONTRASEÑA
          </v-card-title>
          <v-card-text>

            <v-text-field
            v-model="password"
            label="Contraseña"
            name="password"
            prepend-icon="mdi-lock"
            type="password"
            :rules="passwordRules"
            />

            <v-text-field
            v-model="confirmPassword"
            label="Confirmar Contraseña"
            name="confirmPassword"
            prepend-icon="mdi-lock"
            type="password"
            :rules="confirmPasswordRules"
            />

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
           <v-btn color="primary" text class="font-weight-black" @click="aceptar">
            Aceptar
            </v-btn>
            <v-btn v-if="mostrarCancelar" color="primary" text @click.prevent="cerrar">
            Cancelar
            </v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
  </v-form>
</template>

<script>
import ServicioSeguridad from "../services/seguridad";

export default {
  name: "CambioPassword",
  props: ["mostrarCancelar"],
  data(){
    return{
        value: "",
        password: "",
        confirmPassword: "",
        passwordRules: [
            (value) => !!value || 'ingresar contraseña.',
            (value) => (value && value.length >= 6) || 'mínimo 6 caracteres',
        ],
        confirmPasswordRules: [
            (value) => !!value || 'confirmar contraseña',
            (value) => value === this.password || 'Las contraseñas no coinciden.',
        ],
    }
  },
  methods: {
      cerrar(){
          this.$emit("cerrar");
      },
      //async aceptar(){
      async aceptar(){
        if (this.$refs.formCambiarPass.validate()){

          const res = await ServicioSeguridad.cambiarPass(this.password);

          if (res.data.result === 1) {
            this.$root.mensajeExito = "Contraseña actualizada correctamente";
            this.$emit("cerrar");
          } else {
            this.$root.mensajeError =
              res.data.message || "Error al intentar cambiar la contraseña.";            
          }
        }
      
      }
  }
};
</script>

<style>

</style>